import Loading from 'components/Loading';
import React, { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import Router from './router';

const App = () => {
  return (
    <HelmetProvider>
      <Suspense fallback={<Loading />}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </Suspense>
    </HelmetProvider>
  );
};

export default App;
